<template>
  <m-scrollbar>
    <div class="sports-menu" style="margin-left: 5px;">
      <div class="default-sports-menu">
        <sport v-for="sport in sports" v-show="!$route.params.sport || $route.params.sport == sport.id" :key="sport.id" :sport="sport">
          <country v-for="country in sport.countries" :key="country.id" :sport="sport.id" :country="country">
            <league v-for="league in country.leagues" :key="league.id" :sport="sport.id" :league="league">
              <event
                class="event"
                v-for="event in league.events"
                :key="event.id"
                :event="event"
                @click="$router.push(`/prematch/sport/${sport.id}/event/${event.id}`)" />
            </league>
          </country>
        </sport>
      </div>
    </div>
  </m-scrollbar>
</template>

<script>
import ActiveButton from '@/components/buttons/ActiveButton'
import SportIcon from '@/components/icons/SportIcon'
import Sport from '@/components/sports/main_sport_2/Sport'
import Country from '@/components/sports/main_sport_2/Country'
import League from '@/components/sports/main_sport_2/League'
import Event from '@/components/sports/main_sport_2/Event'
import MScrollbar from '@/components/MScrollbar'
import { routeProp } from '@/mixins/routeProp'
import { mapState } from 'vuex'

export default {
  mixins: [ routeProp ],
  components: {
    ActiveButton,
    SportIcon,
    Sport,
    Country,
    League,
    Event,
    MScrollbar
  },
  computed: {
    ...mapState({
      sports: state => state.prematch.menu
    })
  },
  mounted () {
    this.$store.dispatch('prematch/GET_MENU_SPORTS')
  }
}
</script>

<style scoped>
.event:not(:first-child) { border-top: 1px solid rgba(255, 255, 255, .1); }

.compact-sports-menu { display: none; }
.compact-sports-menu .active-button { height: 40px; }
.compact-sports-menu .sport-icon { margin: 12px; }
</style>

<style>
.sports-menu { margin-top: 5px; }
.left-sidebar-layout.compact .default-sports-menu { display: none; }
.left-sidebar-layout.compact .compact-sports-menu { display: block; }
</style>



// WEBPACK FOOTER //
// src/components/sports/main_sport_2/Menu.vue